import React, { useEffect, useState } from "react";
import "./style.scss";
import { ProductDetail } from "views/components/pages/home/hooks";

export const ProductData = (props: ProductDetail) => {
  const { title, frontUnit, item, rearUnit } = props;
  return (
    <div className="productData">
      <span className="productData_title">{title}</span>
      <div className="productData_value">
        <span className="productData_valueUnit">{frontUnit}</span>
        <span className="productData_valueItem">{item}</span>
        <span className="productData_valueUnit">{rearUnit}</span>
      </div>
    </div>
  );
};
